import { createFileRoute, Link } from "@tanstack/react-router";
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { CheckCircle, Home, Mail } from "lucide-react";
import { PublicHeader } from "@/components/PublicHeader";
import { PublicFooter } from "@/components/PublicFooter";

export const Route = createFileRoute("/inscription-success")({
	component: InscriptionSuccessPage,
});

function InscriptionSuccessPage() {
	return (
		<div className="min-h-screen flex flex-col bg-white">
					<PublicHeader />
					
		<div className="flex items-center justify-center py-12 px-4">
			<Card className="w-full max-w-2xl">
				<CardHeader className="text-center">
					<div className="mx-auto mb-4 h-16 w-16 rounded-full bg-green-100 flex items-center justify-center">
						<CheckCircle className="h-10 w-10 text-green-600" />
					</div>
					<CardTitle className="text-3xl text-green-800">
						Inscription validée avec succès !
					</CardTitle>
					<CardDescription className="text-center text-gray-600 text-lg mt-2">
						Votre inscription a été enregistrée et votre moyen de paiement a été
						configuré.
					</CardDescription>
				</CardHeader>
				<CardContent className="space-y-6">
					<Alert className="bg-blue-50 border-blue-200">
						<Mail className="h-4 w-4 text-blue-600" />
						<AlertDescription>
							<p className="font-semibold text-blue-900 mb-2">
								Prochaines étapes :
							</p>
							<ul className="list-disc list-inside space-y-2 text-sm text-blue-800">
								<li>Notre équipe va analyser votre demande d'inscription</li>
								<li>
									Vous recevrez une réponse par email sous 48 heures maximum
								</li>
								<li>
									Nous vous contacterons pour confirmer les détails des cours
								</li>
								<li>
									Un email de confirmation vous a été envoyé à l'adresse que
									vous avez fournie
								</li>
							</ul>
						</AlertDescription>
					</Alert>

					<div className="bg-green-50 p-4 rounded-lg">
						<h4 className="font-semibold text-green-900 mb-2">
							Informations importantes :
						</h4>
						<ul className="list-disc list-inside space-y-1 text-sm text-green-800">
							<li>
								Votre moyen de paiement a été enregistré de manière sécurisée
								via Stripe
							</li>
							<li>
								Aucun prélèvement ne sera effectué avant validation de votre
								inscription
							</li>
							<li>Vous serez informé par email avant chaque facturation</li>
							<li>
								Vous pourrez modifier votre moyen de paiement à tout moment
							</li>
						</ul>
					</div>

					<div className="bg-gray-50 p-4 rounded-lg">
						<h4 className="font-semibold text-gray-900 mb-2">
							Besoin d'aide ?
						</h4>
						<p className="text-sm text-gray-700 mb-3">
							Si vous avez des questions concernant votre inscription, n'hésitez
							pas à nous contacter :
						</p>
						<div className="text-sm text-gray-600 space-y-1">
							<p>
								<strong>Email :</strong> contact@revacours.com
							</p>
						</div>
					</div>

					<div className="flex gap-3 pt-4">
						<Button asChild className="flex-1">
							<Link to="/">
								<Home className="mr-2 h-4 w-4" />
								Retour à l'accueil
							</Link>
						</Button>
					</div>
				</CardContent>
			</Card>
		</div>

		<PublicFooter />
		</div>
	);
}
